module.exports = __webpack_public_path__ + "static/media/tables.e57e8584.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/tables.svg
// module id = 870
// module chunks = 0